type OpsJwtTokens = {
	access_token: string
}

function isOpsJwtTokens(value: unknown): value is OpsJwtTokens {
	if (typeof value !== 'object' || value === null) {
		return false
	}

	const accessToken = (value as { access_token?: unknown }).access_token
	const result = typeof accessToken === 'string' && accessToken.length > 0
	return result
}

export function saveOpsImpersonateTokens(tokensParam: null | string) {
	if (tokensParam == null || tokensParam === '') {
		throw new Error('Query parameter "tokens" is required')
	}

	let parsed: unknown
	try {
		parsed = JSON.parse(tokensParam)
	} catch (error) {
		const parseMessage = error instanceof Error ? error.message : String(error)
		throw new Error(
			`Query parameter "tokens" is not valid JSON: ${parseMessage}`
		)
	}

	if (!isOpsJwtTokens(parsed)) {
		throw new Error(
			'Query parameter "tokens" must be a JSON object with access_token'
		)
	}

	window.localStorage.setItem('jwt', JSON.stringify(parsed))
  window.localStorage.removeItem('impersonated_jwt')
}
